var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.3335L7.26 8.84016C7.47911 8.98635 7.7366 9.06436 8 9.06436C8.2634 9.06436 8.52089 8.98635 8.74 8.84016L14 5.3335M3.33333 12.6668H12.6667C13.0203 12.6668 13.3594 12.5264 13.6095 12.2763C13.8595 12.0263 14 11.6871 14 11.3335V4.66683C14 4.31321 13.8595 3.97407 13.6095 3.72402C13.3594 3.47397 13.0203 3.3335 12.6667 3.3335H3.33333C2.97971 3.3335 2.64057 3.47397 2.39052 3.72402C2.14048 3.97407 2 4.31321 2 4.66683V11.3335C2 11.6871 2.14048 12.0263 2.39052 12.2763C2.64057 12.5264 2.97971 12.6668 3.33333 12.6668Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconEmail);
export default __webpack_public_path__ + "static/media/common_icon_email.6cf1079fdc91ad04c5f6378c9e1fca0f.svg";
export { ForwardRef as ReactComponent };